export const NoticeType = {
    REMIND: 1, // 提醒
    WORK_ORDER: 2, // 工单
}

export const NoticeTypeList = [
    { value: 1, label: "提醒" },
    { value: 2, label: "工单" },
]

export function getNoticeTypeName(type: number) {
    let label = NoticeTypeList.find(item => item.value === type)?.label || null;
    return label
}